module.exports = __webpack_public_path__ + "assets/training-item-gallery.7cc4293a.svg";